import React from 'react';
const WaimaoWebsiteSvg = () => React.createElement("span", { className: "sirius-icon sirius-icon-jump-out-waimao-website" });
WaimaoWebsiteSvg.Enhance = () => React.createElement("span", { className: "sirius-icon sirius-icon-jump-out-waimao-website sirius-icon-jump-out-waimao-website-enhance" });
export default WaimaoWebsiteSvg;
